// Lettered names for IANA zones whose tzdb abbreviation is a bare offset ("+08", "-03").
// ponytail: static snapshot of the backend timezone table's lettered values, plus common names where the table is numeric too;
// a zone missing here shows no abbreviation. Upgrade path: have the backend send a lettered abbreviation per event.
export const LETTERED_TZ_ABBREVIATIONS: Record<string, [standard: string, daylight?: string]> = {
  'Africa/Casablanca': ['WET'],
  'America/Araguaina': ['BRT'],
  'America/Argentina/Buenos_Aires': ['ART'],
  'America/Argentina/Catamarca': ['ART'],
  'America/Argentina/Cordoba': ['ART'],
  'America/Argentina/Jujuy': ['ART'],
  'America/Argentina/La_Rioja': ['ART'],
  'America/Argentina/Mendoza': ['ART'],
  'America/Argentina/Rio_Gallegos': ['ART'],
  'America/Argentina/Salta': ['ART'],
  'America/Argentina/San_Juan': ['ART'],
  'America/Argentina/San_Luis': ['ART'],
  'America/Argentina/Tucuman': ['ART'],
  'America/Argentina/Ushuaia': ['ART'],
  'America/Asuncion': ['PYT'],
  'America/Bahia': ['BRT'],
  'America/Belem': ['BRT'],
  'America/Boa_Vista': ['AMT'],
  'America/Bogota': ['COT'],
  'America/Campo_Grande': ['AMT'],
  'America/Caracas': ['VET'],
  'America/Catamarca': ['ART'],
  'America/Cayenne': ['GFT'],
  'America/Cordoba': ['ART'],
  'America/Cuiaba': ['AMT'],
  'America/Eirunepe': ['ACT'],
  'America/Fortaleza': ['BRT'],
  'America/Guayaquil': ['ECT'],
  'America/Guyana': ['GYT'],
  'America/Jujuy': ['ART'],
  'America/La_Paz': ['BOT'],
  'America/Lima': ['PET'],
  'America/Maceio': ['BRT'],
  'America/Manaus': ['AMT'],
  'America/Mendoza': ['ART'],
  'America/Miquelon': ['PMST', 'PMDT'],
  'America/Montevideo': ['UYT'],
  'America/Noronha': ['FNT'],
  'America/Paramaribo': ['SRT'],
  'America/Porto_Velho': ['AMT'],
  'America/Punta_Arenas': ['CLT'],
  'America/Recife': ['BRT'],
  'America/Rio_Branco': ['ACT'],
  'America/Santarem': ['BRT'],
  'America/Santiago': ['CLT', 'CLST'],
  'America/Sao_Paulo': ['BRT'],
  'Asia/Aden': ['AST'],
  'Asia/Almaty': ['ALMT'],
  'Asia/Amman': ['AST'],
  'Asia/Baghdad': ['AST'],
  'Asia/Bahrain': ['AST'],
  'Asia/Baku': ['AZT'],
  'Asia/Bangkok': ['ICT'],
  'Asia/Brunei': ['BNT'],
  'Asia/Colombo': ['SLST'],
  'Asia/Dhaka': ['BST'],
  'Asia/Dili': ['TLT'],
  'Asia/Dubai': ['GST'],
  'Asia/Ho_Chi_Minh': ['ICT'],
  'Asia/Kabul': ['AFT'],
  'Asia/Kamchatka': ['PETT'],
  'Asia/Kathmandu': ['NPT'],
  'Asia/Katmandu': ['NPT'],
  'Asia/Kuala_Lumpur': ['MYT'],
  'Asia/Kuching': ['MYT'],
  'Asia/Kuwait': ['AST'],
  'Asia/Magadan': ['MAGT'],
  'Asia/Muscat': ['GST'],
  'Asia/Omsk': ['OMST'],
  'Asia/Phnom_Penh': ['ICT'],
  'Asia/Qatar': ['AST'],
  'Asia/Rangoon': ['MMT'],
  'Asia/Riyadh': ['AST'],
  'Asia/Saigon': ['ICT'],
  'Asia/Sakhalin': ['SAKT'],
  'Asia/Singapore': ['SST'],
  'Asia/Tashkent': ['UZT'],
  'Asia/Tbilisi': ['GET'],
  'Asia/Tehran': ['IRST', 'IRDT'],
  'Asia/Ulaanbaatar': ['ULAT'],
  'Asia/Vientiane': ['ICT'],
  'Asia/Vladivostok': ['VLAT'],
  'Asia/Yakutsk': ['YAKT'],
  'Asia/Yangon': ['MMT'],
  'Asia/Yerevan': ['AMT'],
  'Atlantic/Azores': ['AZOT'],
  'Atlantic/Cape_Verde': ['CVT'],
  'Australia/Eucla': ['ACWST'],
  'Australia/Lord_Howe': ['LHST', 'LHDT'],
  'Europe/Istanbul': ['TRT'],
  'Europe/Minsk': ['MSK'],
  'Europe/Samara': ['SAMT'],
  'Indian/Mahe': ['SCT'],
  'Indian/Maldives': ['MVT'],
  'Indian/Mauritius': ['MUT'],
  'Indian/Reunion': ['RET'],
  'Pacific/Apia': ['SST'],
  'Pacific/Bougainville': ['BST'],
  'Pacific/Chatham': ['CHAST', 'CHADT'],
  'Pacific/Easter': ['EAST', 'EASST'],
  'Pacific/Fiji': ['FJT', 'FJST'],
  'Pacific/Kiritimati': ['LINT'],
  'Pacific/Marquesas': ['MART'],
  'Pacific/Norfolk': ['NFT'],
  'Pacific/Noumea': ['NCT'],
  'Pacific/Port_Moresby': ['PGT'],
  'Pacific/Rarotonga': ['CKT'],
  'Pacific/Tahiti': ['TAHT'],
  'Pacific/Tongatapu': ['TOT'],
};
